import { Component } from '@angular/core';
import { FavoriteService } from '../security/favorite';

@Component({
    selector: 'dashboardEmpty',
    templateUrl: './dashboardEmpty.component.html',
    styleUrls: ['./dashboardEmpty.component.css'],
    providers: [FavoriteService]
})

export class dashboardComponentEmpty { }


